import React from "react";
import { motion } from "framer-motion";

// Import service images
import drums from "../images/services/drums.webp";
import guitar from "../images/services/guitar.webp";
import keyboard from "../images/services/keyboard.webp";
import piano from "../images/services/piano.webp";
import theory from "../images/services/theory.webp";
import ukulele from "../images/services/ukulele.webp";

// Service data
const services = [
  { name: "Piano", image: piano },
  { name: "Guitar", image: guitar },
  { name: "Drums", image: drums },
  { name: "Keyboard", image: keyboard },
  { name: "Ukulele", image: ukulele },
  { name: "Theory", image: theory },
];
export default function Services() {
  return (
    <section className="flex min-h-screen flex-col bg-white px-6 py-20 text-black sm:px-12 sm:py-24">
      {/* 🔸 Header */}
      <motion.div
        className="mb-10 text-center"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
      >
        <span className="eyebrow mb-4">What We Teach</span>
        <h2 className="section-heading">Our Music Programs</h2>
        <p className="mt-4 text-base text-ink-soft sm:text-lg">
          Find your sound. Discover your rhythm. Learn from the best.
        </p>
      </motion.div>

      {/* 🟧 Services Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto flex-1">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="relative overflow-hidden rounded-2xl shadow-lg group"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <img
              src={service.image}
              alt={service.name}
              className="w-full h-56 sm:h-64 md:h-72 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition duration-300" />
            <div className="absolute bottom-0 flex w-full items-center justify-center gap-2 bg-gradient-to-t from-black/80 to-transparent py-4">
              <span className="h-1.5 w-1.5 rounded-full bg-brand" />
              <h3 className="text-lg font-bold text-white drop-shadow-md sm:text-xl">
                {service.name}
              </h3>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
